var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.5C2 2.67157 2.67157 2 3.5 2H10C10.2761 2 10.5 2.22386 10.5 2.5C10.5 2.77614 10.2761 3 10 3H3.5C3.22386 3 3 3.22386 3 3.5V14.5C3 14.7761 3.22386 15 3.5 15H10C10.2761 15 10.5 15.2239 10.5 15.5C10.5 15.7761 10.2761 16 10 16H3.5C2.67157 16 2 15.3284 2 14.5V3.5Z",
    fill: "#91979E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1159 6.17991C12.2927 5.96777 12.608 5.9391 12.8201 6.11589L15.8201 8.61589C15.9341 8.71088 16 8.85161 16 9C16 9.14839 15.9341 9.28911 15.8201 9.38411L12.8201 11.8841C12.608 12.0609 12.2927 12.0322 12.1159 11.8201C11.9391 11.608 11.9678 11.2927 12.1799 11.1159L14.719 9L12.1799 6.88411C11.9678 6.70733 11.9391 6.39204 12.1159 6.17991Z",
    fill: "#91979E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9C5 8.72386 5.22386 8.5 5.5 8.5H15C15.2761 8.5 15.5 8.72386 15.5 9C15.5 9.27614 15.2761 9.5 15 9.5H5.5C5.22386 9.5 5 9.27614 5 9Z",
    fill: "#91979E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5ec0ee9d9cfac7d0c0b1b2affb5186ea.svg";
export { ForwardRef as ReactComponent };